// Step — Welcome to EveryPlace (video intro). Shown AFTER Your Profile, so the
// agent has already confirmed their details by the time the video plays.
//
// Serves /assets/welcome-intro.mp4 — the 6.9MB web encode, committed, so this
// works in prod with no CDN and no build-time env var. The 153MB master
// (welcome-video.mp4) stays gitignored: it never reached Render, and because the
// SPA catch-all answers unknown paths with index.html, requesting it returned
// 200 text/html rather than a 404 — so <video> got an HTML document and failed
// silently with nothing in the network tab to point at.
//
// VITE_WELCOME_VIDEO_URL still overrides, if the clip ever outgrows git.

import React from "react";
import { FooterNav } from "./steps_early.jsx";
import { api } from "../lib/api.js";

const VIDEO_URL = import.meta.env.VITE_WELCOME_VIDEO_URL || "/assets/welcome-intro.mp4";

function StepIntro({ agent, onNext }) {
  const first = (agent?.name || "").split(" ")[0] || "there";

  // This is the only step that neither sends nor saves anything, so nothing on
  // the server distinguished an agent who had watched the video from one who had
  // never signed in — which is where the Agent Services preview kept landing.
  //
  // Fire-and-forget, and it never gates the navigation: a breadcrumb is not worth
  // making anyone wait, and in a read-only preview this 403s by design (looking at
  // somebody's welcome video is not watching it for them).
  function handleNext() {
    api.post("/v1/onboarding-gate/intro-seen", {}).catch(() => {});
    onNext();
  }
  return (
    <div style={{ maxWidth: 960 }}>
      <div className="ep-eyebrow" style={{ color: "var(--ep-sunset)" }}>Welcome to EveryPlace</div>
      <h1 style={{ font: "300 clamp(40px, 5.5vw, 72px)/1.02 var(--ep-font-display)", letterSpacing: "-0.02em", margin: "12px 0 20px" }}>
        Welcome, {first}.
      </h1>
      <p style={{ font: "400 18px/1.55 var(--ep-font-body)", color: "var(--ep-fg-muted)", maxWidth: "56ch", marginBottom: 28 }}>
        Before we get started, here's a quick look at who we are and what joining
        The Laughton Team at EveryPlace means for your business.
      </p>

      {/* The clip is PORTRAIT (1080x1920). Sizing it width:100% in this 960px
          column letterboxed it badly — measured 251x446 of actual video inside a
          960x448 black box, i.e. 74% black with a 353px bar down each side. So
          height drives the size and width follows the aspect ratio, and the frame
          is fit-content so it hugs the video instead of framing empty black.
          max-width keeps it inside the column on narrow screens. */}
      <div style={{ marginBottom: 36, border: "1px solid var(--ep-border)", borderRadius: 2, overflow: "hidden", background: "#000", width: "fit-content", maxWidth: "100%" }}>
        <video
          controls
          playsInline
          preload="metadata"
          style={{ display: "block", height: "min(62vh, 620px)", width: "auto", maxWidth: "100%" }}
          src={VIDEO_URL}
        >
          Your browser can't play this video — you can continue below.
        </video>
      </div>

      <FooterNav onNext={handleNext} canContinue nextLabel="Let's get started"/>
    </div>
  );
}

export { StepIntro };
